import { Map } from 'immutable'
import { getMemberHomeFirstTouchColorScheme } from 'components/MemberHomeFirstTouch/utils'

export function selectIsBreakpoint (breakpoint) {
  return (state) => {
    const hydrationComplete = state.app.get('bootstrapComplete')
    const viewport = state.app.getIn(['viewport', 'width'], 0)
    return hydrationComplete && viewport < breakpoint
  }
}

/**
 * @param {ReduxState} state redux state
 * @returns {Boolean}
 */
export const selectIsTouchable = (state) => state.app.getIn(['viewport', 'touchable'], false)

/**
 * @param {ReduxState} state redux state
 * @returns {Map}
 */
export const selectApp = (state) => state.app || Map()

/**
 * @param {ReduxState} state redux state
 * @returns {Number}
 */
export const selectAppViewportWidth = (state) => selectApp(state).getIn(['viewport', 'width'], 0)

/**
 * @param {ReduxState} state redux state
 * @returns {Number}
 */
export const selectAppViewportHeight = (state) => selectApp(state).getIn(['viewport', 'height'], 0)

const emptyMemberHomeFirstTouch = Map({ visible: false, variation: null })

const emptyHeaderContext = Map({ visible: false, variation: null, colorScheme: null })

/**
 * @param {ReduxState} state
 * @returns {import('immutable').Map}
 */
export const selectMemberHomeFirstTouch = (state) => {
  const m = selectApp(state).get('memberHomeFirstTouch')
  return Map.isMap(m) ? m : emptyMemberHomeFirstTouch
}

let lastHeaderContextInput = null
let lastHeaderContextOutput = null

/**
 * Header styling for the Member Home First Touch overlay: visibility, CMS
 * variation slug, and light/dark color scheme. Returned as an Immutable Map so
 * connectRedux's shallow comparison stays stable across renders.
 * @param {ReduxState} state
 * @returns {import('immutable').Map}
 */
export const selectMemberHomeFirstTouchHeaderContext = (state) => {
  const m = selectMemberHomeFirstTouch(state)
  if (m === lastHeaderContextInput && lastHeaderContextOutput) {
    return lastHeaderContextOutput
  }
  const visible = !!m.get('visible')
  const variation = m.get('variation')
  const resolvedVariation = visible && variation != null ? variation : null
  const colorScheme = visible && variation != null && variation !== ''
    ? getMemberHomeFirstTouchColorScheme(variation)
    : null
  const result = !visible && resolvedVariation == null && colorScheme == null
    ? emptyHeaderContext
    : Map({ visible, variation: resolvedVariation, colorScheme })
  lastHeaderContextInput = m
  lastHeaderContextOutput = result
  return result
}
